<template>
  <app-text-field :type="type" v-bind="attrs" v-model="model" :disabled="disabled" autocomplete="off">
    <template v-if="showRestore" v-slot:label-append>
      <router-link class="link forgot-pass" :to="{name:'restorePass', params: {email: email} }" tabindex="-1">
        {{$t('buttons.forgotpass')}}
      </router-link>
    </template>
    <template v-else v-slot:label-append>
      <slot name="label-append"></slot>
    </template>
    <template v-slot:append>
      <div class="v-input__icon">
        <v-icon color="app-colors-icon-inactive" @click="toggleType">{{icon}}</v-icon>
      </div>
    </template>
    <template v-slot:append-outer>
      <slot name="append-outer"></slot>
    </template>
  </app-text-field>
</template>

<script>
import AppTextField from '@/components/Common/AppTextField.vue';
import omit from 'lodash/omit';

export default {
  name: 'AppPasswordField',
  components: { AppTextField },
  inheritAttrs: false,
  data: function() {
    return {
      attrs: {},
      showPsw: false,
      showRestore: false
    };
  },
  props: {
    disabled: { default: false },
    email: { default: '' },
    value: { default: '' }
  },
  created() {
    this.attrs = omit(this.$attrs, ['clearable']);
    this.showRestore = 'show-restore' in this.$attrs;
  },
  computed: {
    icon() {
      return this.showPsw ? 'fa-eye' : 'fa-eye-slash';
    },
    model: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit('input', val);
      }
    },
    type() {
      return this.showPsw ? 'text' : 'password';
    }
  },
  methods: {
    toggleType() {
      this.showPsw = !this.showPsw;
    }
  }
};
</script>
